import { FrLayer, mapcte, OlMapBaseComponent } from "gmap";
import { Site, SupervisionError } from "solar-bo";
import * as ol from 'ol';
import { IssueTypeHelper } from "@solar/solar/models";
import { ElementRef } from "@angular/core";

export class TooltipIssue {

    //mapTooltip; //document.getElementById('tooltip');
    mapTooltip:any;
    mapTooltipOverlay;
    mapc: OlMapBaseComponent
    constructor(olMapBaseComponent: OlMapBaseComponent, mapTooltip:ElementRef){
        this.configToolTip(olMapBaseComponent,mapTooltip);
    }
    configToolTip(olMapBaseComponent: OlMapBaseComponent, mapTooltip:ElementRef) {
        this.mapc=olMapBaseComponent;
      try {
        this.mapTooltip =mapTooltip.nativeElement;// document.getElementById('mapTooltip');
        this.mapTooltipOverlay = new ol.Overlay({
          element: this.mapTooltip,
          offset: [14, 0]
          //,positioning: 'bottom-left'
  
        });
  
        let map = olMapBaseComponent.map;
        map.addOverlay(this.mapTooltipOverlay);
        map.on('pointermove', this.displayTooltip.bind(this));
      }
      catch (e) {
        console.error(e);
      }
  
    }

    displayTooltip(evt) {
      let pixel = evt.pixel;
      let map = this.mapc.map;
      let feature = map.forEachFeatureAtPixel(pixel, function (feature) {
        return feature;
      });
  
      if (feature) {
        // this.tooltip.style.display = feature ? '' : 'none';
  
        //let fr:FrLayer=feature.get('frlayerinfo');
        let fr: FrLayer = feature[mapcte.frlayerinfo_FieldName];
        //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"displayTooltip feat ",feature);
        //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"displayTooltip fr ",fr);
        if (fr) {
  
          if (fr.ref == 1) {
            // DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"displayTooltip11",feature);
            this.mapTooltipOverlay.setPosition(evt.coordinate);
            let issue: SupervisionError = fr.refObject;
            let issueTypeDesc = IssueTypeHelper.issueGetErrorTypeDescription(issue.type);
            let issueIconClass=IssueTypeHelper.issueGetIconClass(issue.type);
            let issueIcon =('<i class="panel-error [CLASS]"></i>').replace("[CLASS]",issueIconClass); 
            let issueRelevance =IssueTypeHelper.issueGetRelevance(issue.info.relevance);
            this.mapTooltip.innerHTML = fr.name + "<br>"+issueIcon +" " + issueTypeDesc + "<br>Relevance: " + issueRelevance;
            this.mapTooltip.style.display = 'block';
          }
          else if (fr.ref == 3) {
            this.mapTooltipOverlay.setPosition(evt.coordinate);
            this.mapTooltip.innerHTML = fr.name;
            this.mapTooltip.style.display = 'block';
          }
        }
  
      }
      else {
        this.mapTooltip.style.display = 'none';
      }
    };


}